
'use strict';
(function(angular) {
  angular.module('activationApp.services')
    .factory('dataService', function() {
      var data;

      function resetData() {
        data = {
          details: {
            payment: {}
          }
        };
      }

      var ISPs = [{
        "code": "TELSTRA",
        "name": "Telstra",
        "label": "Telstra",
        "logo": "",
        "can_subscribe": true,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "IINET",
        "name": "iiNet",
        "label": "iiNet",
        "phone_number": "",
        "logo": "",
        "can_subscribe": true,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "OPTUS",
        "name": "Optus",
        "label": "Optus",
        "phone_number": "",
        "logo": "",
        "can_subscribe": true,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "ADAM INTERNET",
        "name": "Adam Internet",
        "label": "Adam Internet",
        "phone_number": "",
        "logo": "",
        "can_subscribe": true,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "TPG",
        "name": "TPG",
        "label": "TPG",
        "logo": "",
        "can_subscribe": false,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "DODO",
        "name": "Dodo",
        "label": "Dodo",
        "logo": "",
        "can_subscribe": false,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "EXETEL",
        "name": "Exetel",
        "label": "Exetel",
        "logo": "",
        "can_subscribe": false,
        "subscription_link": "",
        "subscription_description": ""
      }, {
        "code": "OTHER",
        "name": "Other",
        "label": "Other",
        "logo": "",
        "can_subscribe": false,
        "subscription_link": "",
        "subscription_description": ""
      }];

      var retailers = [
        {
          code: 'BING_LEE',
          name: 'Bing Lee'
        },
        {
          code: 'DICK_SMITH',
          name: 'Dick Smith'
        },
        {
          code: 'DOMAYNE',
          name: 'Domayne'
        },
        {
          code: 'FETCH',
          name: 'Fetch'
        },
        {
          code: 'HARVEY_NORMAN',
          name: 'Harvey Norman'
        },
        {
          code: 'HILLSONG',
          name: 'Hillsong'
        },
        {
          code: 'JOYCE_MAYNE',
          name: 'Joyce Mayne'
        },
        {
          code: 'JB_HIFI',
          name: 'JB Hi-Fi'
        },
        {
          code: 'KOGAN',
          name: 'Kogan'
        },
        {
          code: 'QANTAS_FREQUENT_FLYER',
          name: 'Qantas Frequent Flyer'
        },
        {
          code: 'TELSTRA',
          name: 'Telstra',
        },
        {
          code: 'THE_GOOD_GUYS',
          name: 'The Good Guys'
        },
        {
          code: 'OPTUS_SMART_SPACES',
          name: 'Optus Smart Spaces'
        },
        {
          code: 'MY_DEAL',
          name: 'My Deal',
        },
        {
          code: 'BIG_W',
          name: 'Big W',
        },
      ];

      var titles = ["Mr", "Miss", "Mrs", "Ms"];

      var states = [{
        label: 'ACT',
        name: 'Australian Capital Territory'
      }, {
        label: 'NSW',
        name: 'New South Wales'
      }, {
        label: 'VIC',
        name: 'Victoria'
      }, {
        label: 'QLD',
        name: 'Queensland'
      }, {
        label: 'SA',
        name: 'South Australia'
      }, {
        label: 'WA',
        name: 'Western Australia'
      }, {
        label: 'NT',
        name: 'Northern Territory'
      }, {
        label: 'TAS',
        name: 'Tasmania'
      }];

      resetData();

      return {
        resetData: resetData,

        getData: function() {
          return data;
        },

        getISPs: function() {
          return ISPs;
        },

        getRetailers: function() {
          return retailers;
        },

        getTitles: function() {
          return titles;
        },

        getStates: function() {
          return states;
        },

        showPartners: function() {
          return false;
        }
      };
    })
    .value('version', '0.9');
})(angular);

